module.exports = __webpack_public_path__ + "static/media/icon-menu.8cbaef71.svg";